import {
  Desktop,
  MediaContextProvider,
  Mobile,
  Tablet
} from '@/components/atoms/media'
import MobileBrowser from '@/components/organisms/imagesBrowser/mobileBrowser'
import { SlideItemsCount } from '@/components/organisms/productsSlider/horizontalTitledProductsSlider'
import { FC } from 'react'

type SimpleImageBrowserProps = {
  imageUrls: string[]
  slidesToShow?: SlideItemsCount
  slidesPerGroup?: SlideItemsCount
}

const SimpleImageBrowser: FC<SimpleImageBrowserProps> = ({
  imageUrls,
  slidesToShow = { desktop: 3, tablet: 3, mobile: 1 },
  slidesPerGroup = { desktop: 3, tablet: 3, mobile: 1 }
}) => {
  const props = {
    imageUrls,
    showBullets: false,
    spaceBetween: 15,
    arrowsTopPercent: 50,
    width: 800,
    height: 534
  }
  return (
    <MediaContextProvider>
      <Desktop>
        <MobileBrowser
          slidesToShow={slidesToShow.desktop}
          slidesPerGroup={slidesPerGroup.desktop}
          {...props}
        />
      </Desktop>
      <Tablet>
        <MobileBrowser
          slidesToShow={slidesToShow.tablet}
          slidesPerGroup={slidesPerGroup.tablet}
          {...props}
        />
      </Tablet>
      <Mobile>
        <MobileBrowser
          slidesToShow={slidesToShow.mobile}
          slidesPerGroup={slidesPerGroup.mobile}
          {...props}
        />
      </Mobile>
    </MediaContextProvider>
  )
}

export default SimpleImageBrowser
